import React from "react";
import "./loader.css";

// Animated three-dot indicator. It inherits the text colour, so it works inside any button.
export const Dots = ({ className = "" }) => (
  <span className={`dots ${className}`.trim()} role="status" aria-label="Բեռնում է">
    <i />
    <i />
    <i />
  </span>
);

// Centered loading state for whole pages and sections (`compact` for blocks inside a page).
export const PageLoader = ({ compact = false }) => (
  <div className={`page-loader${compact ? " compact" : ""}`}>
    <Dots />
    <span className="page-loader-label">Բեռնում է</span>
  </div>
);

export default Dots;
